import React, {PropTypes} from 'react';
import Translator from 'bazinga-translator';

const ShowAllDrafts = (props)=> {
    const { settings, title, desc } = props;
    return (
    <div className="box-drafts -all">
        <h2>{title}</h2>
        <p>{desc}</p>
        <a className="btn" href={settings.link}>{Translator.trans('drafts.see_all_button', [], 'app')}</a>
        <div className="box-drafts__sum"><h2>{settings.count}</h2><p>{settings.name_variant}</p></div>
        <div className="box-picture__pencils"></div>
    </div>
    )
};

ShowAllDrafts.propTypes ={
    settings: PropTypes.object,
    title: PropTypes.string,
    desc: PropTypes.string
};

export default ShowAllDrafts;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/ShowAllDrafts.jsx